<div class="formly-field-wrap">
  @if (!options.formState.disabled && !field.props['disabled'] && !field.props['readonly']) {
    <div class="card-content">
      @if (mediaModel.media.length > 0 || mediaModel.selectedFiles.length > 0) {
        <div class="media-grid">
          <!-- Process all existing image files first -->
          @for (medium of mediaModel.media; let i = $index; track $index) {
            <div class="media-thumb">
              <div class="thumb-container">
                @if(isImage(medium.mediaType)) {
                  <img [src]="medium.fileId | httpImgSrc" [alt]="medium.originalname" />
                } @else {
                  <div class="file-thumb">
                    <app-dynamic-icon [name]="getMediaIcon(medium.mediaType)"></app-dynamic-icon>
                    <span class="file-name">{{ medium.originalname }}</span>
                  </div>
                }
                <div class="thumb-overlay" (click)="removeExistingMedia(i)">
                  <app-dynamic-icon name="close" color="danger"></app-dynamic-icon>
                </div>
              </div>
            </div>
          }
          <!-- Then process all newly selected files -->
          @for (file of mediaModel.selectedFiles; let i = $index; track $index) {
            <div class="media-thumb">
              <div class="thumb-container">
                @if(isImageFile(file)) {
                  <img [src]="getFilePreview(file)" [alt]="file.name" />
                } @else {
                  <div class="file-thumb">
                    <app-dynamic-icon [name]="getFileIcon(file)"></app-dynamic-icon>
                    <span class="file-name">{{ file.name }}</span>
                  </div>
                }
                <div class="thumb-overlay" (click)="removeFile(i)">
                  <app-dynamic-icon name="close" color="danger"></app-dynamic-icon>
                </div>
              </div>
            </div>
          }

          @if (getTotalMediaCount() < maxFiles) { 
            <div class="media-thumb add-thumb" (click)="fileInput.click()">
              <app-dynamic-icon name="add" size="large"></app-dynamic-icon>
              <span>{{ 'COMMON.ADD' | translate }}</span>
            </div>
          }
        </div>
      }

      @if (getTotalMediaCount() === 0) {
        <div class="upload-prompt">
          <ion-button fill="outline" (click)="fileInput.click()">
            <app-dynamic-icon name="camera-outline" slot="start"></app-dynamic-icon>
            {{ 'COMMON.ADD_MEDIA' | translate }}
          </ion-button>
        </div>
      }

      <input #fileInput type="file" multiple accept="image/*,video/*,.pdf, .xls, .doc, .docx, .xlsx, .txt"
        (change)="onFileSelect($event)" style="display: none;">
    </div>
} @else {
  <!-- Disabled form or disabled field -->
  <div class="mosaic-container">
    <app-mosaic-gallery [media]="getImageMedia()" [maxVisible]="5" [thumbnailSize]="field.props['size'] || 'medium'">
       <ng-template #empty>
         <div class="empty-state">
           <app-dynamic-icon name="image" size="large"></app-dynamic-icon>
           <p>{{ 'COMMON.NO_MEDIA_AVAILABLE' | translate }}</p>
         </div>
       </ng-template>
    </app-mosaic-gallery>
  </div>
  @if (getNonImageMedia().length > 0) {
    <div class="non-image-files">
      @for(medium of getNonImageMedia(); track medium.fileId) {
        @if (medium.mediaType.indexOf('video') !== -1) {
          <video class="car-log-video" controls>
            <source [src]="medium.fileId | httpImgSrc" [type]="medium.mediaType">
            {{ 'COMMON.VIDEO_NOT_SUPPORTED' | translate }}
          </video>
        } @else if (medium.mediaType.indexOf('audio') !== -1) {
          <audio class="car-log-audio" controls>
            <source [src]="medium.fileId | httpImgSrc" [type]="medium.mediaType">
            {{ 'COMMON.AUDIO_NOT_SUPPORTED' | translate }}
          </audio>
        } @else if (medium.mediaType.indexOf('pdf') !== -1) {
          <app-pdf-viewer class="pdf-viewer" [fileId]="medium.fileId"></app-pdf-viewer>
        } @else {
          <div class="unsupported-media" (click)="downloadItem(medium)">
            <i class="fa-solid fa-eye-slash"></i>
            <p class="filename">{{ medium.originalname }}</p>
            <p class="tip">{{ 'COMMON.CLICK_TO_DOWNLOAD' | translate }}</p>
          </div>
        }
      }
    </div>
  }
}
</div>